import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default function initializeMap(latitude, longitude, mapReference, mapId) {
  var extraOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return new google.maps.Map(mapReference.current, _objectSpread(_objectSpread({
    center: {
      lat: latitude,
      lng: longitude
    },
    mapId: mapId || 'DEMO_MAP_ID',
    zoom: 11,
    mapTypeControl: true,
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.LEFT_BOTTOM
    },
    streetViewControl: true,
    zoomControl: true,
    fullscreenControl: true
  }, extraOptions), {}, {
    styles: [{
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi.business',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi.hotel',
      elementType: 'all',
      stylers: [{
        visibility: 'off'
      }]
    }]
  }));
}